import {
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    EventEmitter,
    Input,
    Output,
    Type,
    ViewChild
} from '@angular/core';
import {WrenchBottomSheetHeaderDirective} from "./directives/wrench-bottom-sheet-header.directive";
import {WrenchBottomSheetContentDirective} from "./directives/wrench-bottom-sheet-content.directive";
import {WrenchBottomSheetFooterDirective} from "./directives/wrench-bottom-sheet-footer-directive";
import {UtilitiesService} from "../core/_services/utilities.service";

@Component({
    selector: 'app-wrench-bottom-sheet',
    standalone: true,
    imports: [
        WrenchBottomSheetHeaderDirective,
        WrenchBottomSheetContentDirective,
        WrenchBottomSheetFooterDirective,
    ],
    templateUrl: './wrench-bottom-sheet.component.html',
    styleUrls: ['./wrench-bottom-sheet.component.scss']
})
export class WrenchBottomSheetComponent {

    @Input() headerType: Type<any>;
    @Input() contentType: Type<any>;
    @Input() footerType: Type<any>;

    header: ComponentRef<any>;
    content: ComponentRef<any>;
    footer: ComponentRef<any>;

    @ViewChild(WrenchBottomSheetHeaderDirective, {static: true}) headerAnchor: WrenchBottomSheetHeaderDirective;
    @ViewChild(WrenchBottomSheetContentDirective, {static: true}) contentAnchor: WrenchBottomSheetContentDirective;
    @ViewChild(WrenchBottomSheetFooterDirective, {static: true}) footerAnchor: WrenchBottomSheetFooterDirective;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private utilitiesService: UtilitiesService) {
    } // constructor()
    init() {
        this.loadHeader();
        this.loadContent();
        this.loadFooter();
    }

    loadHeader() {
        if (this.headerType) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.headerType);
            const viewContainerRef = this.headerAnchor.viewContainerRef;
            viewContainerRef.clear();
            const componentRef = viewContainerRef.createComponent(componentFactory);
            this.header = componentRef.instance;
        }
    } // loadHeader()

    loadContent() {
        if (this.contentType) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.contentType);
            const viewContainerRef = this.contentAnchor.viewContainerRef;
            viewContainerRef.clear();
            const componentRef = viewContainerRef.createComponent(componentFactory);
            this.content = componentRef.instance;
        }
    } // loadContent()

    loadFooter() {
        if (this.footerType) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.footerType);
            const viewContainerRef = this.footerAnchor.viewContainerRef;
            viewContainerRef.clear();
            const componentRef = viewContainerRef.createComponent(componentFactory);
            this.footer = componentRef.instance;
        }
    } // loadFooter()
}
